<template>
    <div class="modif-grille">
        <FicheDescriptive v-bind:patientCourant="patientCourant" class="NouvellePage" />
        <div class="container-button-valider">
            <button class="valider" v-on:click="affiche">Valider</button>
        </div>
    </div>
    <div class="modal" id="modal">

        <div class="modal-container">
            L'utilisateur est modifié<br />
            <button v-on:click="retour" class="valider-link" id="modal-retour">valider</button>

            <a @click="quitter" href="#" class="modal_close" id="modal-close">&times</a>
        </div>
    </div>
</template>

<style scoped>
    .modif-grille {
        display: flex;
        flex-direction: column;
        align-items: center;
        
    }
    .container-button-valider {
        margin-top: auto;
        text-align: center;
    }

    button.valider {
        background-color: #01358d;
        color: white;
        width: 100px;
        height:40px;
        border-radius: 50px;
        margin-top: 5px;
    }

    .modal-container {
        position: fixed;
        top: 50%;
        left: 50%;
        padding: 50px;
        color:white;
        background-color: #124573;
        text-align: center;
        transform: translate(-50%, -50%);
        border-radius: 30px;
    }
    .valider-link{
        text-decoration:none;
        background-color:green;
        padding:5px;
        color:white;
        font-size:10px;
        text-transform:uppercase;
        border-radius:5px;
    }
    .modal_close{
        color:white;
        position:absolute;
        right:15px;
        top:15px;
        text-decoration:none;

    }
</style>

<script>
    import { defineComponent } from 'vue';
    import FicheDescriptive from '../components/FicheDescriptive.vue';
    import Patient from '../script/Patient.js';
   
    export default defineComponent({
        components: {
            FicheDescriptive
        },
        data: function () {
            return {
                
            }
        },
        computed: {
            patientCourant() {
                return this.$store.getters["ConnexionStore/getPatientCourant"]
            }
        },

        methods: {
            
            affiche() {
                console.log(this.$store.getters["ConnexionStore/getPatientCourant"]);//test 1 affichage du patient
                /*alert("affiche");*/
                console.log("Test :", this.patientCourant);// vérification qu'il s'agit du même que le test 1
                console.log("Test :", this.patientCourant.Identifiant);// vérification de l'affichage de l'identifiant
                Patient.modifierPatient(this.patientCourant);
                document.getElementById('modal').style.display = 'block'

            },
            quitter() {
                document.getElementById('modal').style.display = 'none'
            },
            retour() {
                history.back();
            }
        },

        props: {

        },
        mounted() {

        }

        ,
        created() {

        }

    });
</script>